'use client';

import type { EnglishIqMessagesType } from '../english-iq-messages-type';
import { useEnglishIqStageFocus } from '../hooks/wizard/use-english-iq-stage-focus';

interface IEnglishIqCompletingProps {
  hasError: boolean;
  isBusy: boolean;
  messages: EnglishIqMessagesType['wizard'];
  onRetry: () => void;
}

export function EnglishIqCompleting({
  hasError,
  isBusy,
  messages,
  onRetry,
}: IEnglishIqCompletingProps): React.JSX.Element {
  const stageRef = useEnglishIqStageFocus<HTMLDivElement>();
  if (hasError) {
    return (
      <div
        className="grid min-h-[50svh] place-items-center py-10 text-center"
        ref={stageRef}
        role="alert"
        tabIndex={-1}
      >
        <div className="max-w-md space-y-5">
          <div className="space-y-2">
            <h2 className="text-2xl font-black tracking-tight">{messages.errorTitle}</h2>
            <p className="text-sm leading-6 text-muted-foreground">{messages.errorBody}</p>
          </div>
          <button
            className="min-h-12 rounded-xl bg-foreground px-6 py-3 text-sm font-bold text-background transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none"
            disabled={isBusy}
            onClick={onRetry}
            type="button"
          >
            {messages.retry}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div
      aria-live="polite"
      className="grid min-h-[50svh] place-items-center py-10 text-center"
      ref={stageRef}
      role="status"
      tabIndex={-1}
    >
      <p className="text-sm font-medium text-muted-foreground">{messages.preparing}</p>
    </div>
  );
}
